import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const UpgradeModal = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "multi-hc-upgrade-modal" */ './upgrade-modal')),
    LoadingSkeleton: () => null,
});
